"use client";
import { ConfigTypes } from "@/api/AppApi/common-interfaces/api-enums";
import {
  CategoryStyleTypes,
  ICategory,
} from "@/api/AppApi/services/home/interfaces/ICategory";
import { IProduct } from "@/api/AppApi/services/home/interfaces/IProduct";
import ProductsWithFilters from "../common/produts-with-filters/ProductsWithFilters";
import Categories from "../../common-builder/Category/Categories";
import CategoryProductsContainer from "./CategoryProductsContainer";
import { useTranslation } from "@/hooks/localization/useTranslations";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";

interface Props {
  subcategories: ICategory[];
  products: IProduct[];
  pageCount: number;
  isSubCategory?: boolean;
  categoryId?: string | number;
  searchParams: { [key: string]: string };
}

const CategoryDetailsBlackBox: React.FC<Props> = ({
  subcategories,
  products,
  pageCount,
  isSubCategory,
  categoryId,
  searchParams,
}) => {
  console.log(searchParams)
  const t = useTranslation();
  const getCompany = useGetCompanyQuery();
  const { show_category_image, show_subcategory_image } =
    getCompany?.data?.result?.theme?.components?.product ?? {};
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
      {subcategories?.length > 0 && (
        <Categories
          isSubCategory={isSubCategory}
          data={subcategories}
          configurations={{
            style_type: CategoryStyleTypes.circle_icon,
            type: ConfigTypes.carousel,
          }}
          show_category_image={show_category_image!}
          show_subcategory_image={show_subcategory_image!}
          text={{
            view_all: t.view_all,
          }}
        />
      )}
      <CategoryProductsContainer productNum={products?.length}>
        <ProductsWithFilters
          products={products}
          pageCount={pageCount}
          searchParams={searchParams}
          categoryId={categoryId}
        />
      </CategoryProductsContainer>
    </div>
  );
};
export default CategoryDetailsBlackBox;
